const HELPER_TEXT = {
  magicLinkDescription: 'Enter your email address to receive a login link.',
  magicLinkSent: 'Please check your email and follow the login link.',
  verifyingLink: 'Logging you in…',
  linkFailed:
    'This login link is invalid or has expired. Please request a new one.',
}

const LINKS = {
  requestNewLink: 'Request a new link',
}

const BUTTONS_LABEL = {
  sendLink: 'Login',
}

const LOGIN_LABELS = {
  email: 'Email',
}

const LOGIN_STATUSES = {
  ok: 'OK',
}

export { LINKS, HELPER_TEXT, BUTTONS_LABEL, LOGIN_LABELS, LOGIN_STATUSES }
